import ExportTable from './ExportTable';

export default ExportTable;
